
import { initializeApp } from "firebase/app";
import {
    getFirestore, getDocs, collection, query, onSnapshot, orderBy, doc, updateDoc, addDoc, limit, startAfter, where, deleteDoc, setDoc, writeBatch, getDoc, documentId,
} from "firebase/firestore";

// Importa Auth
import { getAuth } from "firebase/auth";

const firebaseConfig = {
    apiKey: "AIzaSyDR8QFPsVFa4Yk0Bski-70-dVTXKDQ8Czo",
    authDomain: "xeroo-farmacias-moscovich.firebaseapp.com",
    projectId: "xeroo-farmacias-moscovich",
    storageBucket: "xeroo-farmacias-moscovich.firebasestorage.app",
    messagingSenderId: "183321620896",
    appId: "1:183321620896:web:4ca0edda899ec3a26734c5"
};

// Inicializa Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);

// Exporta las funciones necesarias
export {
    db, collection, query, onSnapshot, getDocs, orderBy, doc, updateDoc, addDoc, auth, limit, startAfter, where, deleteDoc, setDoc, writeBatch, getDoc, documentId
};
